import styled from 'styled-components/macro';
import { column, row } from 'src/App/Styles/styles-helpers';

export const CommandsContain = styled.div`
	${column}
	flex:1;
	gap: 1em;
	overflow: hidden;
`;
export const CommandsList = styled.div`
	${row}
	align-items: space-between;
	flex-wrap: wrap;
	gap: 10px;
	overflow-y: auto;
	padding: 10px;
`;
